// extracted by mini-css-extract-plugin
export default {"PeoplePicker__picker":"styles_PeoplePicker__picker__sc+-t","PeoplePicker__picker--empty":"styles_PeoplePicker__picker--empty__tWsan"};